<!-- eslint-disable -->
<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div class="p-4">
        <div class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
          <h3 class="mb-0">Кандидат</h3>
        </div>

        <form @submit.prevent="submit">
          <!-- First Row -->
          <div class="row g-3 align-items-center">
            <!-- First Input: Имя -->
            <div class="col-lg-4">
              <label for="nameInput">Имя</label>
              <input
                  type="text"
                  id="nameInput"
                  v-model="temp.name"
                  class="form-control"
                  autocomplete="off"
              />
            </div>

            <!-- Checkbox Group: Пол -->
            <div class="col-lg-4 d-flex justify-content-center">
              <div class="d-flex gap-3">
                <!-- Checkbox: М -->
                <div class="form-check">
                  <input
                      class="form-check-input"
                      type="radio"
                      id="genderMale"
                      :disabled="checkIsDisabled"
                      :value="1"
                      v-model="temp.gender"
                      autocomplete="off"
                  />
                  <label class="form-check-label" for="genderMale">М</label>
                </div>

                <!-- Checkbox: Ж -->
                <div class="form-check">
                  <input
                      class="form-check-input"
                      type="radio"
                      id="genderFemale"
                      :disabled="checkIsDisabled"
                      :value="2"
                      v-model="temp.gender"
                      autocomplete="off"
                  />
                  <label class="form-check-label" for="genderFemale">Ж</label>
                </div>

                <!-- Checkbox: П -->
                <div class="form-check">
                  <input
                      class="form-check-input"
                      type="radio"
                      id="genderOther"
                      :disabled="checkIsDisabled"
                      :value="3"
                      v-model="temp.gender"
                      autocomplete="off"
                  />
                  <label class="form-check-label" for="genderOther">П</label>
                </div>
              </div>
            </div>

            <!-- Second Input: Напоминание -->
            <div class="col-lg-4">
              <label for="remindInput">Напоминание</label>
              <input
                  type="text"
                  id="remindInput"
                  v-model="temp.remind"
                  class="form-control"
                  autocomplete="off"
              />
            </div>
          </div>


          <!-- Second Row -->
          <div class="row g-3 mt-3">
            <!-- Телефон -->
            <div class="col-lg-4">
              <div class="form-group">
                <label for="phoneInput">Телефон</label>
                <input
                    type="text"
                    id="phoneInput"
                    class="form-control"
                    v-model="temp.phone"
                    placeholder=""
                    autocomplete="off"
                />
              </div>
            </div>

            <!-- Позиция -->
            <div class="col-lg-4">
              <div class="form-group">
                <label for="positionSelect">Позиция</label>
                <select
                    class="form-control"
                    id="positionSelect"
                    :disabled="checkIsDisabled"
                    v-model="temp.positionId"
                >
                  <!-- Options -->
                  <option
                      v-for="position in formattedVacancies"
                      :key="position.id"
                      :value="position.value"
                  >
                    {{ position.label }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Фамилия супруга/супруги -->
            <div class="col-lg-4">
              <div class="form-group">
                <label for="pairInput">Фамилия супруга/супруги</label>
                <input
                    id="pairInput"
                    class="form-control"
                    :disabled="temp.gender !== 3"
                    v-model="temp.pair"
                    placeholder=""
                    autocomplete="off"
                />
              </div>
            </div>
          </div>

          <div class="row g-3 mt-3">
            <!-- Паспорт -->
            <div class="col-lg-4">
              <div class="form-group">
                <label for="passportInput">Паспорт</label>
                <input
                    type="text"
                    id="passportInput"
                    v-model="temp.passport"
                    :disabled="checkIsDisabled"
                    class="form-control"
                    placeholder=""
                    autocomplete="off"
                />
              </div>
            </div>

            <!-- Статус -->
            <div class="col-lg-4">
              <div class="form-group">
                <label for="statusSelect">Статус</label>
                <div v-if="dialogStatus === 'update'">
                  <select
                      id="statusSelect"
                      v-model="temp.status"
                      :disabled="checkIsDisabled || (userRole !== 'grand_admin' && userRole !== 'manager' && temp.status !== 'Приезд')"
                      class="form-control"
                  >
                    <option value="Приезд">Приезд</option>
                    <option value="Работает">Работает</option>
                    <option value="Не работает">Не работает</option>
                  </select>
                </div>
                <div v-else>
                  <select
                      id="statusSelect-"
                      v-model="temp.status"
                      :disabled="checkIsDisabled"
                      class="form-control"
                  >
                    <option value="Приезд">Приезд</option>
                    <option value="Работает">Работает</option>
                    <option value="Не работает">Не работает</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Дни -->
            <div class="col-lg-4">
              <div class="form-group">
                <label for="daysInput">Дни</label>
                <input
                    type="text"
                    id="daysInput"
                    v-model="temp.days"
                    :disabled="checkIsDisabled"
                    class="form-control"
                    placeholder=""
                    autocomplete="off"
                />
              </div>
            </div>
          </div>

          <div class="row g-3 mt-3">
            <!-- Pesel -->
            <div class="col-lg-4">
              <div class="form-group">
                <label>Pesel</label>
                <div class="d-flex align-items-center">
                  <div class="form-check me-3">
                    <input
                        type="radio"
                        id="peselYes"
                        class="form-check-input"
                        :disabled="checkIsDisabled"
                        value="yes"
                        v-model="peselOption"
                    />
                    <label class="form-check-label" for="peselYes">Да</label>
                  </div>
                  <div class="form-check">
                    <input
                        type="radio"
                        id="peselNo"
                        class="form-check-input"
                        :disabled="checkIsDisabled"
                        value="no"
                        v-model="peselOption"
                    />
                    <label class="form-check-label" for="peselNo">Нет</label>
                  </div>
                </div>
                <input
                    v-if="peselOption === 'yes'"
                    type="text"
                    v-model="temp.pesel"
                    :disabled="checkIsDisabled"
                    class="form-control mt-2"
                    placeholder="Введите Pesel"
                    autocomplete="off"
                />
              </div>
            </div>

            <!-- Дата приезда или Работает от -->
            <div class="col-lg-4">
              <div class="form-group">
                <label for="arrivalDateInput">{{ listQuery.status == 3 ? 'Работает от' : 'Дата приезда' }}</label>


                <flat-pickr
                    v-model="temp.arrivalDate"
                    :disabled="checkIsDisabled"
                    class="form-control"
                    :config="flatpickrConfig"
                    placeholder="Выберите дату"
                />


              </div>
            </div>

            <!-- Часы -->
            <div class="col-lg-4">
              <div class="form-group">
                <label for="hoursInput">Часы</label>
                <input
                    type="text"
                    id="hoursInput"
                    v-model="temp.hours"
                    :disabled="checkIsDisabled"
                    class="form-control"
                    placeholder=""
                    autocomplete="off"
                />
              </div>
            </div>
          </div>

          <div class="row g-3 mt-3">
            <div class="col-lg-4">
              <div class="form-group">
                <label>Дата рождения</label>
                <flat-pickr
                    v-model="temp.birth"
                    :disabled="checkIsDisabled"
                    class="form-control"
                    :config="flatpickrConfig"
                    placeholder="Выберите дату"
                />
              </div>
            </div>


            <!-- Рекрутер -->
            <div class="col-lg-4">
              <div class="form-group">
                <label>Рекрутер</label>
                <select
                    v-model="temp.recruiterId"
                    class="form-control"
                >
                  <option
                      v-for="recruiter in recruiters"
                      :key="recruiter.id"
                      :value="recruiter.id"
                  >
                    {{ recruiter.name }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Комментарий -->
            <div class="col-lg-4">
              <div class="form-group">
                <label>Комментарий</label>
                <textarea
                    v-model="temp.comment"
                    :disabled="checkIsDisabled"
                    class="form-control"
                    placeholder=""
                ></textarea>
                <button
                    type="button"
                    class="btn btn-secondary btn-sm mt-2"
                    @click="dialogBlackListVisible = true"
                >
                  Чёрный список
                </button>
              </div>
            </div>
          </div>


          <!-- Buttons -->
          <div class="mt-4">
            <a href="/candidates/status1" class="btn btn-danger me-3">Отменить</a>

            <button class="btn btn-primary" @click="!isEditPage ? createData() : updateData()">
              <i class="bi bi-plus"></i> Сохранить
            </button>
          </div>
        </form>
      </div>
    </div>


    <!-- Modal Backdrop -->
    <div class="modal" tabindex="-1" role="dialog" :class="{ 'd-block': dialogBlackListVisible }">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <!-- Modal Header with Close Icon -->
          <div class="modal-header">
            <h5 class="modal-title">Черный список</h5>
            <button type="button" class="btn-close" @click="dialogBlackListVisible = false">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
                      <textarea
                          class="form-control description"
                          v-model="temp.blackList"
                          rows="10"
                          cols="10"
                      >
                      </textarea>
            </div>
            <br/>
            <button @click="temp.blackList=null;dialogBlackListVisible = false"
                    class="btn btn-danger me-3">Отменить
            </button>

            <button class="btn btn-primary" @click="dialogBlackListVisible = false">
              <i class="bi bi-plus"></i> Сохранить
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {fetchList, fetchCandidate, fetchPv, createCandidate, updateCandidate, deleteCandidate} from '@/api/candidate';
import {fetchPosition} from '@/api/position';

import {parseTime} from '@/utils';
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css'; // Import Flatpickr styles
import 'flatpickr/dist/l10n/ru.js';

const calendarTypeOptions = [
  {key: 'US', display_name: 'USA'},
];

const calendarTypeKeyValue = calendarTypeOptions.reduce((acc, cur) => {
  acc[cur.key] = cur.display_name;
  return acc;
}, {});

export default {
  name: 'candidatesEdit',
  components: {
    FlatPickr,
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'info',
        deleted: 'danger',
      };
      return statusMap[status];
    },
    typeFilter(type) {
      return calendarTypeKeyValue[type];
    },
  },
  data() {
    return {
      isEditPage: false,
      candidateId: null,
      isOpen: false,
      isOpen2: false,
      vacancyDetail: null,
      isOffcanvasVisible: false,
      fromVacancy: false,
      peselOption: 'no',
      peselOption2: 'no',
      userRole: '',
      position: null,
      checkedFields: ['name', 'phone', 'passport', 'pesel'],
      tableKey: 0,
      vacancies: [],
      recruiters: [],
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        isBlackList: 0,
        search: '',
        sort: '+id',
        status: null,
        year: null,
        month: null
      },
      months: [
        {label: 'Январь'},
        {label: 'Февраль'},
        {label: 'Март'},
        {label: 'Апрель'},
        {label: 'Май'},
        {label: 'Июнь'},
        {label: 'Июль'},
        {label: 'Август'},
        {label: 'Сентябрь'},
        {label: 'Октябрь'},
        {label: 'Ноябрь'},
        {label: 'Декабрь'},
      ],
      calendarTypeOptions,
      sortOptions: [{label: 'ID Ascending', key: '+id'}, {label: 'ID Descending', key: '-id'}],
      statusOptions: ['published', 'draft', 'deleted'],
      showReviewer: false,
      formattedVacancies: [],
      temp: {
        name: '',
        vacancyCandidateId: null,
        is_pair: 0,
        pesel: '',
        recruiterId: '',
        birth: '',
        gender: 1
      },
      temp2: {
        name: '',
        vacancyCandidateId: null,
        gender: 3,
        is_pair: 1,
        pesel: '',
        recruiterId: '',
        birth: ''
      },
      flatpickrConfig: {
        dateFormat: 'd-m-Y', // Format the date as YYYY-MM-DD
        locale: 'ru', // Set locale to Russian
        allowInput: true, // Allow manual input
        altInput: true, // Show a human-readable format in the input
        altFormat: 'd-m-Y', // Human-readable format (e.g., 1 января 2023)
        static: false, // Show the calendar inline (optional)
      },
      dialogFormVisible: false,
      dialogFieldsVisible: false,
      dialogBlackListVisible: false,
      dialogStatus: '',
      textMap: {
        update: 'Edit',
        create: 'Create',
      },
      dialogPvVisible: false,
      pvData: [],
      fields: [
        {label: '№', name: 'vacancy_number', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Проект', name: 'vacancy_title', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Кандидат', name: 'name', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Номер телефона', name: 'phone', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Работает от', name: 'arrivalDate1', showAsMain: false, showForArrival: false, showForRetired: false},
        {label: 'Статус', name: 'status', showAsMain: true, showForArrival: false, showForRetired: false},
        {label: 'Дата приезда', name: 'arrivalDate2', showAsMain: false, showForArrival: true, showForRetired: false},
        {label: 'Дата', name: 'arrivalDate3', showAsMain: false, showForArrival: false, showForRetired: true},
        {label: 'Рекрутер', name: 'recruiter', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Координатор', name: 'coordinator', showAsMain: true, showForArrival: true, showForRetired: true}
      ],
      rules: this.setRules(),
      downloadLoading: false,
    };
  },
  created: async function () {
    this.parseStatusFromUrl();
    this.checkBlackList();
    this.getList(this.listQuery);

    const {path, params} = this.$route;
    if (path.includes('/candidates/create')) {
      if (params.id) {
        const id = parseInt(params.id);
        this.temp.positionId = id;
        this.temp2.positionId = id;
      }
    }
  },
  watch: {},
  methods: {
    menuItemToggle() {
      this.isOpen = !this.isOpen; // Toggles the `open` class
    },
    menuItemToggle2() {
      this.isOpen2 = !this.isOpen2; // Toggles the `open` class
    },
    closeOffcanvas() {
      this.isOffcanvasVisible = false;  // Close the offcanvas
    },
    handleRightClick(event) {
      event.preventDefault(); // Disable the default context menu

      // Get the cell data
      const cellData = event.target.innerText;

      // Call your method with cell data
      this.openCustomContextMenu(cellData, event);

      // Add an event listener to the document to reset filters on click outside
      document.addEventListener('click', this.handleDocumentClick);
    },
    openCustomContextMenu(cellData, event) {
      // Your custom context menu logic
      console.log('Right-clicked cell data:', cellData);
      this.listQuery.search = cellData;
      this.handleFilter();
    },
    handleDocumentClick(event) {
      const tableElement = this.$refs.candidates1.$el; // Access the DOM element of the table
      // Check if the click was outside the table
      if (tableElement && !tableElement.contains(event.target)) {
        this.resetFilters();
        document.removeEventListener('click', this.handleDocumentClick);
      }

      const tableElement2 = this.$refs.candidates2.$el; // Access the DOM element of the table
      // Check if the click was outside the table
      if (tableElement2 && !tableElement2.contains(event.target)) {
        this.resetFilters();
        document.removeEventListener('click', this.handleDocumentClick);
      }

      const tableElement3 = this.$refs.candidates3.$el; // Access the DOM element of the table
      // Check if the click was outside the table
      if (tableElement3 && !tableElement3.contains(event.target)) {
        this.resetFilters();
        document.removeEventListener('click', this.handleDocumentClick);
      }
    },
    resetFilters() {
      this.listQuery.search = '';
      this.handleFilter();
      // Your logic to reset filters
      console.log('Filters reset');
    },
    arrivalLabel() {
      return 'Работает от';
      // return this.listQuery.status === 3 ? 'Работает от' : 'Дата приезда';
    },
    formatDate(date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
    parseStatusFromUrl() {
      const path = this.$route.path;
      const regex = /status(\d+)/;
      const match = path.match(regex);
      if (match && match[1]) {
        this.listQuery.status = match[1];
      } else {
        this.listQuery.status = this.$route.query.status || null;
      }
      if (this.listQuery.status) {
        this.getList()
      }
    },
    checkBlackList() {
      const fullUrl = window.location.href;
      this.listQuery.isBlackList = fullUrl.includes('black-list') ? 1 : 0;
    },
    // isArrivalDateRequired() {
    //   return this.temp.status === 'Приезд';
    // },
    setRules() {
      return {
        name: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        phone: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        passport: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        /*  pesel: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],*/
        comment: [{required: false, message: 'Обязательное поле', trigger: 'blur'}],
        gender: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
      };
    },
    async getList() {
      const path = this.$route.path;
      if (path.includes('/edit/')) {
        const id = path.split('/edit/')[1];

        const data = await fetchCandidate(id);
        this.list = data.candidates.items;
        this.vacancies = data.vacancies;
        this.userRole = data.userRole;
        this.formatVacancies(this.vacancies);
        this.recruiters = data.recruiters;


        this.isEditPage = true;
        this.candidateId = id;
        const foundCandidate = this.list.find(candidate => candidate.id === Number(this.candidateId));
        if (foundCandidate) {
          console.log('Found candidate:', foundCandidate);
          this.temp = JSON.parse(JSON.stringify(foundCandidate));
        } else {
          console.warn(`Candidate with ID ${this.candidateId} not found in the list.`);
        }
      } else {
        const data = await fetchList(this.listQuery);
        this.list = data.candidates.items;
        this.vacancies = data.vacancies;
        this.userRole = data.userRole;
        this.formatVacancies(this.vacancies);
        this.recruiters = data.recruiters;
        this.isEditPage = false;
        console.log('Create mode');
      }
    },
    formatVacancies(data) {
      let options = [];
      this.vacancies.forEach(vacancy => {
        if (vacancy.is_active === 1) {
          vacancy.vacancy_candidates.forEach(candidate => {
            options.push({
              label: `${vacancy.title}/${candidate.position}`,
              value: candidate.id
            });
          });
        }
      });
      this.formattedVacancies = options;
    },
    handleFilter() {
      //alert(this.listQuery.year);
      const searchQuery = this.listQuery.search?.trim(); // Ensure search is trimmed and exists

      if (!searchQuery) {  // If searchQuery is null, undefined, or empty, reset the filter
        this.listQuery.search = '';
        this.listQuery.page = 1;
        this.getList();  // Return full list
      } else if (searchQuery.length === 1) {
        // Do nothing if length is 1
        return;
      } else if (searchQuery.length > 1) {  // If length > 1, search and save
        this.listQuery.page = 1;
        this.getList();
      }
    },
    handleFilterStatus(status) {
      this.listQuery.status = status;
      this.getList();
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: 'Successful operation',
        type: 'success',
      });
      row.status = status;
    },
    sortChange(data) {
      const {prop, order} = data;
      this.sortBy(prop, order);
    },
    sortBy(prop, order) {
      if (order === 'ascending') {
        this.listQuery.sort = '+' + prop;
      } else {
        this.listQuery.sort = '-' + prop;
      }
      this.handleFilter();
    },
    resetTemp() {
      this.temp = {};
    },
    handleCreate(fromVacancy = false) {
      if (!fromVacancy) {
        this.resetTemp();
      }
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    handleExport() {

    },
    handleBlackList() {
      this.dialogBlackListVisible = true;
    },
    createData() {
      if (this.temp.status === 'Приезд' && !this.temp.arrivalDate) {
        alert('Введите дату приезда');
        return
      }
      if (this.peselOption === 'yes' && this.temp.pesel === '') {
        alert('Введите pesel');
        return
      }
      if (this.peselOption2 === 'yes' && this.temp.pesel2 === '') {
        alert('Введите pesel для пары');
        return
      }
      //  this.$refs['dataForm'].validate((valid) => {
      // if (valid) {
      createCandidate(this.temp).then((response) => {
        if (response.redirect) {
          this.$router.push('/black-list/index');
        } else if (this.temp.gender === 3 && this.temp2.name !== '') {
          createCandidate(this.temp2).then(() => {
            console.log('Pair created');
          });
        } else if (this.fromVacancy) {
          //window.location.href = '/#/candidates/status1';
          //this.$router.push('/candidates/status1');
        } else {
          //window.location.href = '/#/candidates/status1';
        }

        //this.list.unshift(this.temp);
        this.dialogFormVisible = false;

        this.$router.push('/candidates/status1');

        /*      this.$notify({
                title: 'Успешно',
                message: 'Успешно',
                type: 'success',
                duration: 2000,
              });*/
      });
      //  }
      // });
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row); // copy obj
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    updateData() {
      /*     this.$refs['dataForm'].validate((valid) => {
             if (valid) {*/
      const tempData = Object.assign({}, this.temp);
      updateCandidate(tempData).then(() => {
        for (const v of this.list) {
          if (v.id === this.temp.id) {
            const index = this.list.indexOf(v);
            this.list.splice(index, 1, this.temp);
            break;
          }
        }
        this.dialogFormVisible = false;
        /*    this.$notify({
              title: 'Успешно',
              message: 'Данные успешно изменены',
              type: 'success',
              duration: 2000,
            });*/
        let redirect = '1';
        if (this.temp.status === 'Работает') {
          redirect = '3';
        } else if (this.temp.status === 'Не работает') {
          redirect = '4';
        }
        //window.location.href = '/#/candidates/status' + redirect;
        //window.location.href = '/#/candidates/status3';
      });

      this.$router.push('/candidates/status1');
      /*  }
      });*/
    },
    handleDelete(row) {
      if (confirm('подтвердить удаление')) {
        deleteCandidate(row).then(() => {
          this.$notify({
            title: 'Успешно',
            message: 'Удалено',
            type: 'success',
            duration: 2000,
          });
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        });
      }
    },
    handleFetchPv(pv) {
      fetchPv(pv).then(response => {
        this.pvData = response.data.pvData;
        this.dialogPvVisible = true;
      });
    },
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    handleClick(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = e => {
        this.temp.image = e.target.result;
      };
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j]);
        } else {
          return v[j];
        }
      }));
    },
    handleDownload() {
      /*      this.downloadLoading = true;
            import('@/vendor/Export2Excel').then(excel => {
              const tHeader = ['№', 'Вакансия', 'Цена', 'Статус', 'Дата', 'Кандидат', 'Телефон', 'Рекрутер', 'Координатор', 'Комментарий'];
              const filterVal = ['number', 'project', 'rate', 'status', 'arrivalDate', 'name', 'phone', 'coordinator', 'recruiter', ''];
              const list = this.list;
              const data = this.formatJson(filterVal, list);
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: 'candidates',
                autoWidth: this.autoWidth,
                bookType: this.bookType,
              });
              this.downloadLoading = false;
            });*/
    },
  },
  computed: {
    checkIsDisabled() {
      return (
          this.listQuery.isBlackList === 1 &&
          !['grand_admin', 'admin', 'manager'].includes(this.userRole)
      );
    },
  },
  async mounted() {
    try {
      this.getList();
    } catch (error) {
      console.error('Error fetching data:', error);
      // Handle errors gracefully (e.g., display an error message)
    }
  },
};
</script>

<style scoped>

.form-control {
  height: 40px !important;
  padding: 8px 16px !important;
}

.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

.calendar {
  border: 1px solid #ddd;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-width: 900px;
  padding: 10px;
  box-sizing: border-box;
}

.header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background-color: #f0f0f0;
  font-weight: bold;
}

.day {
  padding: 10px;
  text-align: center;
}

.month-controls {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: minmax(100px, auto);
  gap: 1px;
}

.cell {
  border: 1px solid #ddd;
  background-color: #fff;
  text-align: center;
  padding: 5px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.cell.empty {
  background-color: #f9f9f9;
}

.date {
  font-size: 1.2em;
  margin-bottom: 5px;
}

.time-inputs {
  display: flex;
  justify-content: space-between;
  gap: 2px;
}

input[type="time"] {
  padding: 2px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.footer {
  margin-top: 10px;
  text-align: center;
}

.footer-text {
  margin-bottom: 10px;
}

.footer-button {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.footer-button button {
  padding: 5px 15px;
  font-size: 16px;
  cursor: pointer;
}

@media (max-width: 600px) {
  .calendar {
    width: 100%;
  }
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #000;
  opacity: 0.5;
  transition: opacity 0.2s ease;
}

.btn-close:hover {
  opacity: 1;
}

</style>
<!-- eslint-enable -->
